// Single source of truth for business info (NAP) used in meta tags, JSON-LD and the UI.
// Keep this consistent with the Google Business Profile listing.
export const SITE = {
    name: '561-FIX-HOME',
    legalName: '561-FIX-HOME LLC',
    url: 'https://www.561fixhome.com',
    logo: 'https://www.561fixhome.com/logo.png',
    image: 'https://www.561fixhome.com/assets/images/1.webp',
    bookingUrl: 'https://book.housecallpro.com/book/561-FIX-HOME-LLC/512e6b50105140ba8ce64285f928a9e6',
    license: 'CGC1537206',
    phone: '(561) 349-4663',
    phoneE164: '+15613494663',
    address: {
        streetAddress: '23257 FL-7 #216',
        addressLocality: 'Boca Raton',
        addressRegion: 'FL',
        postalCode: '33428',
        addressCountry: 'US',
    },
    locatedIn: 'Sandalfoot Professional Building',
    hours: 'Open 24/7',
    googleRating: { value: '5.0', count: 38 },
    region: 'South Florida', // used in copy
    counties: ['Palm Beach County', 'Broward County'], // used in schema areaServed
    priceRange: '$$',
    // Social / review profiles (Google Business Profile, Yelp, Facebook...) for schema sameAs.
    sameAs: [],
};

export const absoluteUrl = (path = '/') => `${SITE.url}${path === '/' ? '/' : path}`;
